import { ApplicationRef, Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TipologicaDTO } from '../../models/tipologica-d-t-o';
import { TipologicheDTO } from '../../models/tipologiche-dto';
import { map, pluck, shareReplay, switchMap, tap } from "rxjs/operators";
// import { CodiceTipoPagamento } from "../../constants/tipo-pagamemto";
import { CodiceTipiRichiedente } from "../../constants/tipi-richiedente";
import { TipiDocumento } from "../../constants/tipi-documenti";
import { ConfigurationService } from '../../../configuration/configuration-service';
import { PORTAL_SHELL_APP_PATH } from 'angular-portal-shell-app';
import { TribunaleDTO } from '../../models/tribunale-dto';

export const ORGANO_CORTE_DI_APPELLO = 'CA';
export const ORGANO_TAR = 'TA';
export const TRIBUNALE = 'T';

@Injectable({
	providedIn: 'root'
})
export class TipologicheService {


	documentiObbligatoriByTipoRichiedente = {
		[(CodiceTipiRichiedente.CODICE_RICORRENTE)]: [TipiDocumento.ALTRO],
		[(CodiceTipiRichiedente.CODICE_EREDE_RICORRENTE)]: [TipiDocumento.DSAN_EREDI, TipiDocumento.ALTRO],
		[(CodiceTipiRichiedente.CODICE_PERSONA_GIURIDICA_RAPPRESENTANTE_LEGALE)]: [TipiDocumento.ATTO_COSTITUTIVO,
		TipiDocumento.ALTRO],
		[(CodiceTipiRichiedente.CODICE_PROCURATORE_ANTISTATARIO)]: [TipiDocumento.ALTRO],
		[(CodiceTipiRichiedente.CODICE_EREDE_PROCURATORE_ANTISTATARIO)]: [TipiDocumento.DSAN_EREDI, TipiDocumento.ALTRO],
		[(CodiceTipiRichiedente.CODICE_TUTORE_PROCURATORE_LEGALE)]: [TipiDocumento.PROCURA,
		TipiDocumento.PROVVEDIMENTO_DI_INCASSO_SOMME,
		TipiDocumento.PROVVEDIMENTO_DEL_GIUDICE_TUTELARE, TipiDocumento.ALTRO],
		[(CodiceTipiRichiedente.CODICE_CURATORE_FALLIMENTARE)]: [TipiDocumento.ATTO_COSTITUTIVO,
		TipiDocumento.PROVVEDIMENTO_FALLIMENTO, TipiDocumento.ALTRO]
	};

	tipologiche: Observable<TipologicheDTO>;

	servicePaths: Map<string, string>;

	// urlArgo: string;
	urlDeposito: string;
	urlAnagrafe: string;

	V1_ORGANI_GIURISDIZIONALI: string;
	V1_TRIBUNALI: string;

	constructor(
		private http: HttpClient,
		private configurationService: ConfigurationService,
		private appRef: ApplicationRef,
	) {

		console.log('[TipologicheService]');
		// console.log('[configurationService]', configurationService);

		// this.urlArgo = configurationService.servicePaths.get("ARGO_INTEGRATION_MS_API_URL") + "/v1";
		// console.log('[urlArgo - lib]', this.urlArgo);

		const lingua$ = configurationService.lingua$;
		// console.log('[lingua]', configurationService.servicePaths.get("I18N_MS_API_URL")); 

		this.urlAnagrafe = this.configurationService.servicePaths.get("ANAGRAFE_MS_API_URL") + "/api/v1";

		this.urlDeposito = configurationService.servicePaths.get("DEPOSITO_MS_API_URL") + "/v1";
		console.log('[urlDeposito - lib]', this.urlDeposito);

		//TODO
		// const url: string = this.paths.get_V1Tipologiche();
		// const url: string = this.urlArgo + '/tipologiche';
		const url: string = this.urlDeposito + '/tipologiche';

		this.tipologiche = lingua$.pipe(
			switchMap(lingua =>
				this.http.get<TipologicheDTO>(
					url, { headers: new HttpHeaders({ 'i18n_language': lingua }) }
				)
			),
			tap(_ => appRef.tick()),
			shareReplay()
		);

		//TODO
		// this.tipologiche = this.http.get<TipologicheDTO>(url).pipe(shareReplay());

		//TODO
		// const sscription = this.tipologiche
		// 	.pipe(
		// 		pluck("tipiDocumento"))
		// 	.subscribe(
		// 		t => {
		// 			console.log('[tipologiche]', t);
		// 		},
		// 		_ => {
		// 			// this.modals.failure([
		// 			// 	"recupero.tipologiche.failure"
		// 			// ], []);
		// 		}
		// 	);

		//TODO
		// this.V1_ORGANI_GIURISDIZIONALI = this.urlArgo + '/organiGiurisdizionali?tipo={tipoorgano}';
		this.V1_ORGANI_GIURISDIZIONALI = this.urlDeposito + '/organiGiurisdizionali?tipo={tipoorgano}';
		this.V1_TRIBUNALI = this.V1_ORGANI_GIURISDIZIONALI + '&provincia={provincia}';
	}

	getTipiDocumento$(): Observable<Array<TipologicaDTO>> {
		return this.tipologiche.pipe(
			map((tipogiche: TipologicheDTO) => tipogiche.tipiDocumento),
			shareReplay());
	}

	getTipiDomicilio$(): Observable<Array<TipologicaDTO>> {
		return this.tipologiche.pipe(
			map((tipogiche: TipologicheDTO) => tipogiche.tipiDomicilio),
			shareReplay());
	}

	getTipoEmittente$(): Observable<Array<TipologicaDTO>> {
		return this.tipologiche.pipe(
			map((tipogiche: TipologicheDTO) => tipogiche.tipiEmittente),
			shareReplay());
	}

	getRts$(): Observable<Array<TipologicaDTO>> {
		return this.tipologiche.pipe(
			map((tipogiche: TipologicheDTO) => tipogiche.rts),
			shareReplay());
	}

	getTipoContenzioso$(): Observable<Array<TipologicaDTO>> {
		return of(this.getTipoContenzioso()).pipe(shareReplay());
	}

	getTipiRuoloAltriSoggetti$(): Observable<Array<TipologicaDTO>> {
		return  this.tipologiche.pipe(
			map((tipogiche: TipologicheDTO) => tipogiche.tipiRuoloAltriSoggetti),
			shareReplay());
	}

	getTipiDeposito$(): Observable<Array<TipologicaDTO>> {
		return  this.tipologiche.pipe(
			map((tipogiche: TipologicheDTO) => tipogiche.tipoDeposito),
			shareReplay());
	}

	getTipiCatasto$():Observable<Array<TipologicaDTO>> {
		return this.tipologiche.pipe(
			map((tipologiche: TipologicheDTO) => tipologiche.tipoCatasto),	
			shareReplay());
	}

	private filterTipiPagamentoByTipoRichiedente(
		tipiPagamento: Array<TipologicaDTO>, tipoRichiedente: String): Array<TipologicaDTO> {
		// console.log('[tipoRichiedente]', tipoRichiedente);

		const isPG =
			tipoRichiedente == CodiceTipiRichiedente.CODICE_PERSONA_GIURIDICA_RAPPRESENTANTE_LEGALE ||
			tipoRichiedente == CodiceTipiRichiedente.CODICE_CURATORE_FALLIMENTARE;

		return isPG ?
			tipiPagamento :
			tipiPagamento.filter(tipoPagamento => tipoPagamento.codice != 'C');

	}

	getTipoPagamentoByTipoRichiedente$(tipoRichiedente: String): Observable<Array<TipologicaDTO>> {
		return this.getTipiModalitaDiPagamento$().pipe(
			map(tipiPagamento => this.filterTipiPagamentoByTipoRichiedente(tipiPagamento, tipoRichiedente))
		);
	}

	getCortiAppello$(): Observable<Array<TipologicaDTO>> {
		return
		//TODO
		// const url: string = this.paths.get_V1Organo(ORGANO_CORTE_DI_APPELLO);
		// return this.http.get<Array<TipologicaDTO>>(url);
	}

	getTar$(): Observable<Array<TipologicaDTO>> {
		return
		//TODO
		// const url: string = this.paths.get_V1Organo(ORGANO_TAR);
		// return this.http.get<Array<TipologicaDTO>>(url);
	}

	getTribunali$(siglaProvincia: string): Observable<Array<TribunaleDTO>> {
		return this.http.get<Array<TribunaleDTO>>(this.urlAnagrafe + `/tribunale/provincia/${siglaProvincia}/`).pipe(shareReplay());
	}

	get_V1Tribunale(tribunale: string, siglaProvincia: string): string {
		const regexTipoOrgano: RegExp = new RegExp('{tipoorgano}', 'gi');
		const regexProvincia: RegExp = new RegExp('{provincia}', 'gi');
		return this.V1_TRIBUNALI
			.replace(regexTipoOrgano, tribunale)
			.replace(regexProvincia, siglaProvincia);
	}

	getTipoContenzioso(): Array<TipologicaDTO> {
		return [
			{ codice: '1', descrizione: 'Contenziosi giustizia amministrativa e Corte dei Conti', id: '1', codiceLingua: 'it_IT' },
		];
	}

	public getTipiModalitaDiPagamento$(): Observable<TipologicaDTO[]> {
		return this.tipologiche.pipe(pluck('tipiModalitaDiPagamento'));
	}

	getTipoDescrizioneCausale$(): Observable<Array<TipologicaDTO>> {
		return this.tipologiche.pipe(
			map((tipogiche: TipologicheDTO) => tipogiche.tipoDescrizioneCausale),
			shareReplay());
	}

}